import { Component, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { UserInfoService } from "../../../main/objects/user-info.service";
import { MainMenuService } from "../../../main/objects/main-menu.service";
import { ConstantsService } from "../../../services/constants.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    showHeader: boolean = false;
    el: HTMLElement = document.createElement('cayuse-header');
    onPrems: boolean = false;
''

    constructor(
        private userInfo: UserInfoService,
        private mainMenu: MainMenuService,
        private constants: ConstantsService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService & { [name: string]: any },
        private location: Location) {};

    ngOnInit() {
        this.userInfo.GetUserInfo().then(() => {
            this.showHeader = true;
            this.onPrems = this.userInfo.userInfo.loginType !== 'cayuse';
           
            if(this.onPrems) {
                this.initOnPremsHeader();
            } else {
                this.initHostedHeader();
            }
            
            this.el.setAttribute('product', this.constants.Aplications[this.userInfo.userInfo.selectedApp ? this.userInfo.userInfo.selectedApp.id : -1] || 'RS');

            this.el.addEventListener('navigationChange', (event: any) => this.navigationChanged(event.detail));
            this.el.addEventListener('productSelected', (event: any) => this.productSelected(event.detail));

            this.el.style.setProperty('--height', '60px');

            const toggle = document.createElement('div');
            toggle.className ='navbar-inverse hamb';
            toggle.slot = 'toggle-menu';
            this.el.appendChild(toggle);
            
            const toggleBtn = document.createElement('button');
            toggleBtn.className = 'navbar-tbtn';  
            toggleBtn.title = 'Show/Hide Menu';
            toggleBtn.onclick = () => {
                if ($('.navbar-collapse').hasClass('in')) {
                    this.mainMenu.HideMenu();
                } else {
                    this.mainMenu.ShowMenu();                
                }
  
                $('.navbar-tbtn').attr("disabled", "disabled");
                setTimeout(function () {
                    $('.navbar-tbtn').removeAttr('disabled');
                   
                }, 500);
            };                
            toggle.appendChild(toggleBtn);

            const toggleIcon = document.createElement('i');
            toggleIcon.className = 'fa fa-bars hamburger-icon';  
            toggleBtn.appendChild(toggleIcon);            
           
            if(this.userInfo.userInfo.customerLogo) {
                const customerImage = document.createElement('img');
                customerImage.src = this.userInfo.userInfo.customerLogo;
                customerImage.height = 22;
                customerImage.width = 40;
                customerImage.slot = 'customer-image';

                this.el.setAttribute('customer-image', 'SMALL');
                this.el.appendChild(customerImage);
            }
            
            const groupDiv: HTMLElement = document.createElement('div') as any;
            groupDiv.slot = "cayuse-header-group";

            const cayuseHeaderGroups = document.createElement('cayuse-header-groups') as any;
            cayuseHeaderGroups.groups = this.getGroups();
            cayuseHeaderGroups.addEventListener('selectGroup', (event) => this.groupSelected(event.detail));
            groupDiv.appendChild(cayuseHeaderGroups);

            this.el.appendChild(groupDiv);
            document.getElementById('cayuse-common-header').appendChild(this.el);
        });

        this.$rootScope.$on('reloadHeader', this.reloadHeaderComponent);
        this.$rootScope.$on('startProgressBar', ($event, speed) => (this.el as any).startReload(85, speed));
        this.$rootScope.$on('completeProgessBar', () => (this.el as any).completeReload());
    }

    private reloadHeaderComponent = () => {
        (this.el as any).updateProducts(this.getProductList());
        (this.el.childNodes[1].firstChild as any).updateGroups(this.getGroups());
    }

    private initHostedHeader() {
          this.el.setAttribute('user-id', this.userInfo.userInfo.cayuseUserId);         
          this.el.setAttribute('authentication-token', this.$rootScope.globals.currentUser.token);
          this.el.setAttribute('host', this.userInfo.userInfo.proxyURL || this.userInfo.userInfo.onePlatformURL); //this.host
         //(this.el as any).userId = this.userInfo.userInfo.cayuseUserId;
    }

    private initOnPremsHeader() {
        this.el.setAttribute('is-on-premise', 'true');
        (this.el as any).user = {
            firstName: this.userInfo.userInfo.firstName,
            lastName: this.userInfo.userInfo.lastName,
            username: this.userInfo.userInfo.username,
        };

        (this.el as any).products = this.getProductList();
    }

    private getProductList() {
        return this.userInfo.userInfo.applications.map(a => {
            return {
                displayName: a.name,
                path: this.constants.Aplications[a.id] || 'Home',
                image: a.icon
            }
        });
    }

    private getGroups() {
        const groups = [];
            
        if (this.userInfo.userInfo.sites.length > 0) {
            groups.push({
                id: "site",
                caption: "Site",
                selected: {
                    id: this.userInfo.userInfo.currentSite.id,
                    label: this.userInfo.userInfo.currentSite.name
                },
                items: this.userInfo.userInfo.sites.map(s => {
                    return {
                        id: s.id,
                        label: s.name
                    }
                })
            })
        }

        if (this.userInfo.userInfo.roles.length > 0) {
            groups.push({
                id: "role",
                caption: "Role",
                selected: {
                    id: this.userInfo.userInfo.currentRole.id,
                    label: this.userInfo.userInfo.currentRole.name
                },
                items: this.userInfo.userInfo.roles.map(r => {
                    return {
                        id: r.id,
                        label: r.name
                    }
                })
            })
        }

        if (this.userInfo.userInfo.currentRole.id === 1 && this.userInfo.userInfo.groups.length > 0) {
            groups.push({
                id: "group",
                caption: "Group",
                selected: {
                    id: this.userInfo.userInfo.currentGroup.id,
                    label: this.userInfo.userInfo.currentGroup.name
                },
                items: this.userInfo.userInfo.groups.map(g => {
                    return {
                        id: g.id,
                        label: g.name
                    }
                })
            })
        }

        return groups;
    }

    private navigationChanged(item) {
        switch (item){
            case '/':
                this.location.go('home');
                break;
            case '/logout':
                this.userInfo.Logout();
                this.mainMenu.Dispose();
                break;
            case 'customerImage':
                window.location.href = this.userInfo.userInfo.customerUrl;
                break;
            default: 
                window.location.href = item;
        }
    }

    private productSelected(item: string) {

        if(this.onPrems) {
            const app = this.userInfo.userInfo.applications.find(a => a.id == Object.keys(this.constants.Aplications).find(key => this.constants.Aplications[key] === item));
            this.userInfo.ChangeApplication(app);
            this.$rootScope.$broadcast('changingApp');
        } else {
            if(!item.startsWith('https')){
                item = `${this.userInfo.userInfo.onePlatformURL}${item}`;
            }
            window.location.href = item;
            
        }
    }

    private groupSelected(item) {        
        switch(item.groupId){
            case 'site':
                this.$rootScope.$broadcast('changingSite', item.id);
                break;
            case 'role':
                this.$rootScope.$broadcast('changingRole', item.id);
                break;
            case 'group':
                this.$rootScope.$broadcast('changingPIGroup', item.id);
                break;
                        
        }
    }
}
